// This file is automatically generated. Do not edit manually.

import { PartRevisionView } from "src/api/generated/erp/db/types/tables/partRevisionView";
import { PartRevisionOperationView } from "src/api/generated/erp/db/types/tables/partRevisionOperationView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SitePartRevisionQueryApi {
	export async function getPartRevisionSelectionOptions(args: {
		partId: number;
		currentPartRevisionId?: number | null | undefined;
		searchQuery?: string;
		disablePartRevisionId?: number | null | undefined;
	}): Promise<Array<PartRevisionView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/parts/sitePart/revision/getPartRevisionSelectionOptions",
			method: "POST",
			data: {
				partId: args.partId,
				currentPartRevisionId: args.currentPartRevisionId,
				searchQuery: args.searchQuery,
				disablePartRevisionId: args.disablePartRevisionId,
			},
		});
		return response as Array<PartRevisionView>;
	}

	export async function getPartRevisionOperations(args: {
		partRevisionId: number;
	}): Promise<Array<PartRevisionOperationView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/parts/sitePart/revision/getPartRevisionOperations",
			method: "POST",
			data: {
				partRevisionId: args.partRevisionId,
			},
		});
		return response as Array<PartRevisionOperationView>;
	}

	export async function getSitePartRevisionIdForCatalogPartRevision(args: {
		catalogPartRevisionId: number;
		partId: number;
	}): Promise<number | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/parts/sitePart/revision/getSitePartRevisionIdForCatalogPartRevision",
			method: "POST",
			data: {
				catalogPartRevisionId: args.catalogPartRevisionId,
				partId: args.partId,
			},
		});
		return response === "" ? null : (response as number | null);
	}
}
